import { render, staticRenderFns } from "./menzhenjiaofei.vue?vue&type=template&id=7c703a16&scoped=true&"
import script from "./menzhenjiaofei.vue?vue&type=script&lang=js&"
export * from "./menzhenjiaofei.vue?vue&type=script&lang=js&"
import style0 from "./menzhenjiaofei.vue?vue&type=style&index=0&id=7c703a16&rel=stylesheet%2Fless&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c703a16",
  null
  
)

export default component.exports